import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { listWorkspaces, slackInstallUrl } from "../api/workspaces";
import { Button } from "../components/Button";
import { Card } from "../components/Card";

export default function Onboarding() {
  const nav = useNavigate();

  useEffect(() => {
    void (async () => {
      const list = await listWorkspaces();
      if (list.length > 0) nav("/reports", { replace: true });
    })();
  }, [nav]);

  function connect() {
    window.location.href = slackInstallUrl({ returnPath: "/onboarding" });
  }

  function skip() {
    nav("/reports", { replace: true });
  }

  return (
    <div className="min-h-[70vh] grid place-items-center">
      <Card className="max-w-lg text-center p-10">
        <div className="text-3xl mb-4">⚡</div>
        <h1 className="font-display text-2xl font-semibold mb-2">Almost there</h1>
        <p className="text-sm text-text-muted mb-6">
          Daybrief needs at least one Slack workspace connected to generate reports
          for your team.
        </p>
        <div className="flex justify-center mb-3">
          <Button onClick={connect}>Connect a workspace →</Button>
        </div>
        <button
          onClick={skip}
          className="text-xs text-text-muted underline hover:text-ink-800"
        >
          Skip for now
        </button>
      </Card>
    </div>
  );
}
